/**
 * Mock options for Criteria Dialog dropdowns
 */

export const mockTableNameOptions = [
  { id: 1, description: "SHIPMENT" },
  { id: 10, description: "CLIENT" },
  { id: 4, description: "DETAIL" },
  { id: 14, description: "RATE GROUP" },
  { id: 254, description: "SERVICE CENTER" },
];

// Mock field names for different tables
export const mockFieldNamesByTable: Record<
  number,
  Array<{ id: number; description: string }>
> = {
  1: [
    // SHIPMENT
    { id: 1, description: "WEIGHT" },
    { id: 2, description: "DISTANCE" },
    { id: 3, description: "PIECES" },
    { id: 4, description: "ORIGIN_ZIP" },
    { id: 5, description: "DEST_ZIP" },
  ],
  10: [
    // CLIENT
    { id: 10, description: "CLIENT_CODE" },
    { id: 11, description: "CLIENT_NAME" },
    { id: 12, description: "ACCOUNT_NUMBER" },
  ],
  4: [
    // DETAIL
    { id: 20, description: "COMMODITY_CLASS" },
    { id: 21, description: "NMFC_CODE" },
  ],
  14: [
    // RATE GROUP
    { id: 30, description: "RATE_GROUP_CODE" },
    { id: 31, description: "RATE_GROUP_NAME" },
  ],
  254: [
    // SERVICE CENTER
    { id: 40, description: "SERVICE_CENTER_CODE" },
    { id: 41, description: "SERVICE_CENTER_NAME" },
  ],
};

// Mock lookup types for different tables
export const mockLookupTypesByTable: Record<
  number,
  Array<{ id: number; description: string }>
> = {
  1: [
    // SHIPMENT table
    { id: 1, description: "GREATER_THAN" },
    { id: 2, description: "LESS_THAN" },
    { id: 3, description: "EQUAL_TO" },
    { id: 4, description: "BETWEEN" },
    { id: 5, description: "IN_LIST" },
  ],
  10: [
    // CLIENT table
    { id: 10, description: "EQUAL_TO" },
    { id: 11, description: "CONTAINS" },
    { id: 12, description: "IN_LIST" },
  ],
  4: [
    // DETAIL table
    { id: 20, description: "EQUAL_TO" },
    { id: 21, description: "IN_LIST" },
    { id: 22, description: "BETWEEN" },
  ],
  14: [
    // RATE GROUP table
    { id: 30, description: "EQUAL_TO" },
    { id: 31, description: "CONTAINS" },
  ],
  254: [
    // SERVICE CENTER table
    { id: 40, description: "EQUAL_TO" },
    { id: 41, description: "IN_LIST" },
    { id: 42, description: "CONTAINS" },
  ],
};

/**
 * Mock data for Start Logic & End Logic API response
 */
export const mockCriteriaLogicOperators = [
  { id: 1, logicValue: "=", seqValue: 1 },
  { id: 2, logicValue: "!=", seqValue: 2 },
  { id: 3, logicValue: "in", seqValue: 3 },
  { id: 4, logicValue: "not in", seqValue: 4 },
  { id: 5, logicValue: "like", seqValue: 5 },
  { id: 6, logicValue: "not like", seqValue: 6 },
  { id: 7, logicValue: "between", seqValue: 7 },
  { id: 8, logicValue: "not between", seqValue: 8 },
  { id: 9, logicValue: ">", seqValue: 9 },
  { id: 10, logicValue: ">=", seqValue: 10 },
  { id: 11, logicValue: "<", seqValue: 11 },
  { id: 12, logicValue: "<=", seqValue: 12 },
];

/**
 * Mock data for Group Logic API response
 */
export const mockCriteriaGroupLogicOperators = [
  { id: 1, logicValue: "AND", seqValue: 1 },
  { id: 2, logicValue: "OR", seqValue: 2 },
];
